import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Team from "./Team";
import WaitList from "./WaitList";
import tokens from "../../theme/tokens";

// Resultado de uma simulação (nada é salvo).
const Modal = ({ isOpen, onClose, teams = [], waitList }) => (
  <Dialog open={Boolean(isOpen)} onClose={onClose} fullWidth maxWidth="md">
    <DialogTitle>Simulação da próxima partida</DialogTitle>
    <DialogContent>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        {[0, 1].map((index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Box sx={{ borderRadius: 2, overflow: "hidden", border: 1, borderColor: "divider" }}>
              <Typography sx={{ px: 2, py: 1, bgcolor: index === 0 ? tokens.color.team1 : tokens.color.team2, color: "#fff", fontFamily: tokens.font.display, fontWeight: 700, fontSize: "1.2rem" }}>
                Time {index + 1}
              </Typography>
              <Box sx={{ p: 1 }}><Team team={teams[index]} /></Box>
            </Box>
          </Grid>
        ))}
      </Grid>
      <WaitList title="Fila de espera" waitList={waitList} />
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={onClose} variant="contained">Fechar</Button>
    </DialogActions>
  </Dialog>
);

export default Modal;
